import Joi from '@hapi/joi'

export const EstateJobMappingListingSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group required`,
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Operation Entity required`,
    }),
    cropTypeID: Joi.number().invalid(0).required().label("Crop Type").messages({
        "any.invalid": `Crop Type required`,
    }),
}